module.exports = __webpack_public_path__ + "static/media/downloadIcon.5f56459b.svg";